import React, { useState } from 'react';
import { Box, Button, Pagination, Select, Stack, TextField, Typography, useMediaQuery, useTheme } from '@mui/material';

const RemotePagination = ({ filterValue, setFilterValue, totalPage, totalCount, compact = false }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [goToPage, setGoToPage] = useState('');

  const isCompact = compact || isMobile;
  const pageCount = Math.max(Number(totalPage) || 1, 1);
  const currentPage = Math.min(Number(filterValue.page) || 1, pageCount);
  const currentPaginate = Number(filterValue.paginate) || Number(localStorage.getItem('rowsPerPage')) || 5;

  const handlePaginateChange = (event) => {
    const selectedPaginate = parseInt(event.target.value, 10);
    setFilterValue((prevState) => ({
      ...prevState,
      page: 1,
      paginate: selectedPaginate,
    }));
    localStorage.setItem('rowsPerPage', selectedPaginate);
  };

  const handleGoToPage = () => {
    const pageNumber = parseInt(goToPage, 10);
    if (pageNumber >= 1 && pageNumber <= pageCount) {
      setFilterValue((prevState) => ({ ...prevState, page: pageNumber }));
      setGoToPage('');
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') handleGoToPage();
  };

  return (
    <Stack
      direction={isCompact ? 'column' : 'row'}
      spacing={2}
      sx={{ width: '100%', my: 2, px: { xs: 0, sm: 1 } }}
      justifyContent="space-between"
      alignItems="center"
    >
      <Pagination
        page={currentPage}
        count={pageCount}
        color="primary"
        variant="outlined"
        shape="rounded"
        siblingCount={isCompact ? 0 : 1}
        boundaryCount={1}
        size={isMobile ? 'small' : 'medium'}
        onChange={(event, page) =>
          setFilterValue((prevState) => ({ ...prevState, page }))
        }
        sx={{ direction: 'ltr', flexShrink: 0 }}
      />

      <Box
        sx={{
          width: isCompact ? '100%' : 'auto',
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'center',
          justifyContent: isCompact ? 'center' : 'flex-end',
          gap: 1.5,
        }}
      >
        <Stack direction="row" alignItems="center" spacing={1}>
          <Typography variant={isMobile ? 'caption' : 'body2'} whiteSpace="nowrap">
            برو به صفحه:
          </Typography>
          <TextField
            value={goToPage}
            onChange={(event) => {
              const value = event.target.value;
              if (/^\d*$/.test(value)) setGoToPage(value);
            }}
            onKeyDown={handleKeyDown}
            size="small"
            aria-label="شماره صفحه"
            sx={{ width: 72 }}
            inputProps={{ min: 1, max: pageCount, style: { textAlign: 'center', padding: '7px 8px' } }}
          />
          <Button
            variant="contained"
            size="small"
            onClick={handleGoToPage}
            disabled={!goToPage || Number(goToPage) < 1 || Number(goToPage) > pageCount}
            sx={{ minWidth: 48, height: 36, px: 1.5 }}
          >
            برو
          </Button>
        </Stack>

        <Stack direction="row" alignItems="center" spacing={0.5}>
          <Typography variant={isMobile ? 'caption' : 'body2'}>تعداد کل:</Typography>
          <Typography variant={isMobile ? 'caption' : 'body2'} fontWeight={700}>
            {totalCount ?? 0}
          </Typography>
        </Stack>

        <Stack direction="row" alignItems="center" spacing={1}>
          <Typography variant={isMobile ? 'caption' : 'body2'} whiteSpace="nowrap">
            {isMobile ? 'تعداد در صفحه:' : 'نمایش در هر صفحه:'}
          </Typography>
          <Select
            native
            size="small"
            value={currentPaginate}
            onChange={handlePaginateChange}
            sx={{ height: 36, minWidth: 64 }}
            inputProps={{ 'aria-label': 'تعداد ردیف در هر صفحه' }}
          >
            {[5, 10, 15].map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </Select>
        </Stack>
      </Box>
    </Stack>
  );
};

export default RemotePagination;
